<template>
    <div class="binding-information">
        <img v-if="iconUrl" :src="iconUrl" width="20" height="20" />
        <span v-if="!iconOnly">{{ name }}</span>
        <img v-if="!iconOnly && avatarUrl && !hideAvatar" :src="avatarUrl" class="avatar-icon" :width="avatarSize" :height="avatarSize" />
        <a v-if="isEditing" @click.stop.prevent="unbind">{{ $t('binding_information.unbind') }}</a>
    </div>
</template>

<script>
import Constants from '../../constants'

export default {
    props: {
        type: { type: String, required: true }, // BindingPlatform in constant.js
        isEditing: { type: Boolean, default: false },
        hideAvatar: { type: Boolean, default: false },
        avatarSize: { type: Number, default: 40 },
        name: { type: String, required: true },
        facebookId: { type: String, required: false },
        lineImageUrl: { type: String, required: false },
        iconOnly: { type: Boolean, default: false },
    },
    data() {
        return {}
    },
    methods: {
        unbind() {
            this.$emit('unbind', this.type);
        },
    },
    computed: {
        isFacebook() {
            return this.type === Constants.BindingPlatform.FACEBOOK;
        },
        isLine() {
            return this.type === Constants.BindingPlatform.LINE;
        },
        avatarUrl() {
            if (this.isFacebook && this.facebookId) {
                return `https://graph.facebook.com/${this.facebookId}/picture?type=square`;
            }
            if (this.isLine && this.lineImageUrl) {
                return this.lineImageUrl;
            }
            return '';
        },
        iconUrl() {
            if (this.isFacebook) {
                return '/img/icon-fb.png';
            }
            if (this.isLine) {
                return '/img/line-chat.png';
            }
            return '';
        },
    },
}
</script>

<style scoped lang="scss">
.binding-information {
    display: flex;
    gap: 4px;
    align-items: center;

    .avatar-icon {
        border-radius: 100px;
    }
}
</style>
